module.exports = __webpack_public_path__ + "static/media/star6.d73613f7.svg";